import React from "react";

import StartPage from "./Views/StartPage";
import GuidesPage from "./Views/GuidesPage";
import ExhbitionResolverPage from "./Views/ExbitionResolverPage";
import ReadmorePage from "./Views/ReadmorePage";

const routes = [
    { 
        path: "/", 
        element: <StartPage />
    },
    { 
        path: "/guides", 
        element: <GuidesPage /> 
    },
    { 
        path: "/guide/:slug", 
        element: <ExhbitionResolverPage />
    },
    { 
        path: "/guide/:slug/readmore", 
        element: <ReadmorePage /> 
    },
];
export default routes;